import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react';
import { ChevronLeft, ChevronRight } from '@kula-ai/icons-core';
import { getMonth, getYear, months } from './dateFieldHelpers';

export const CustomDateHeader = (props) => {
  const {
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  } = props;

  return (
    <Flex justifyContent="space-between" w="100%" alignItems="center" p="0 1em">
      <Icon
        as={ChevronLeft}
        onClick={!prevMonthButtonDisabled ? decreaseMonth : () => {}}
        disabled={prevMonthButtonDisabled}
        color="primary-500"
        w="20px"
        h="20px"
        opacity={!prevMonthButtonDisabled ? 1 : 0.5}
        cursor={prevMonthButtonDisabled ? 'not-allowed' : 'pointer'}
      />
      <KText variant="heading_3">
        {months[getMonth(date)]} {getYear(date)}
      </KText>
      <Icon
        as={ChevronRight}
        onClick={!nextMonthButtonDisabled ? increaseMonth : () => {}}
        disabled={nextMonthButtonDisabled}
        color="primary-500"
        w="20px"
        h="20px"
        opacity={!nextMonthButtonDisabled ? 1 : 0.5}
        cursor={nextMonthButtonDisabled ? 'not-allowed' : 'pointer'}
      />
    </Flex>
  );
};
